import currentScript from './helpers/current-script'

/**
 * Detectar ambiente (development, production, ...)
 */

 const environments = {
    production: {
        applicationUrl: 'https://multicalculo.segfy.com',
        fayeUrl: 'https://mc.fayews.segfy.com',
        legadoGestao: ``,
        applicationUrlApiAutomation: 'https://api.automation.segfy.com',
        selfReference: 'https://app.segfy.com',
        budgetApi: 'https://segfy-budgetapi.segfy.com',
        upfygate: 'https://upfygate.segfy.com',
    },
    productionSegfy: {
        applicationUrl: 'https://api.hfy.segfy.com',
        fayeUrl: 'https://mc.fayews.segfy.com',
        legadoGestao: ``,
        applicationUrlApiAutomation: 'https://api.automation.segfy.com',
        selfReference: 'https://app.segfy.com',
        budgetApi: 'https://segfy-budgetapi.segfy.com',
        upfygate: 'https://upfygate.segfy.com',
    },
    localhost: {
        applicationUrl: 'http://localhost:3001',
        fayeUrl: 'https://mc.fayews.segfy.com',
        legadoGestao: 'http://localhost:58057',
        applicationUrlApiAutomation: 'http://localhost:3000',
        selfReference: 'http://localhost:8080',
        budgetApi: 'http://localhost:5175',
        upfygate: 'http://localhost:5191',
    },
    development: {
        applicationUrl: 'https://api.hfy.segfybeta.com',
        fayeUrl: 'https://mc.fayews.segfy.com/faye',
        legadoGestao: 'https://villa.segfybeta.com',
        applicationUrlApiAutomation: 'https://api-automation.segfybeta.com',
        selfReference: 'https://app.segfybeta.com',
        budgetApi: 'https://segfy-budget.segfybeta.com',
        upfygate: 'https://upfygate.segfybeta.com',
    },
    staging: {
        applicationUrl: 'https://api.hfy.segfybeta.com',
        fayeUrl: 'https://mc.fayews.segfy.com',
        legadoGestao: 'https://villa.segfybeta.com',
        applicationUrlApiAutomation: 'https://api-automation.segfybeta.com',
        selfReference: 'https://app.segfybeta.com',
        budgetApi: 'https://segfy-budget.segfybeta.com',
        upfygate: 'https://upfygate.segfybeta.com',
    },
    localhostGestao: {
        applicationUrl: 'https://api.hfy.segfybeta.com/',
        fayeUrl: 'https://mc.fayews.segfy.com/faye',
        legadoGestao: 'http://localhost:58057',
        applicationUrlApiAutomation: 'https://api-automation.segfybeta.com',
        selfReference: 'http://localhost:8080',
        budgetApi: 'http://localhost:5175',
        upfygate: 'http://localhost:5191',
    }
}

let environment = environments.production

if (currentScript.hasAttribute('data-environment')) {
    const env = currentScript.getAttribute('data-environment')

    if (env === 'productionSegfy') environment = environments.productionSegfy
    if (env === 'development') environment = environments.development
    if (env === 'localhost') environment = environments.localhost
    if (env === 'staging') environment = environments.staging
    if (env === 'localhostGestao') environment = environments.localhostGestao
}

if (currentScript.hasAttribute('data-legado-server')) {
    if (currentScript.getAttribute('data-environment') === 'productionSegfy') {
        environment.legadoGestao = `https://${currentScript.getAttribute('data-legado-server')}.segfy.com`
    }
}


/**
 * Detectar se foi passado um token de usuário
 */
let token;

if (currentScript.hasAttribute('data-token')) {
    token = currentScript.getAttribute('data-token')
}

let tokenAdmin;

if (currentScript.hasAttribute('data-token-admin')) {
    tokenAdmin = currentScript.getAttribute('data-token-admin')
}

let automationBearer;

if (currentScript.hasAttribute('data-automation-bearer')) {
    automationBearer = currentScript.getAttribute('data-automation-bearer')
}

/**
 * Detectar elemento para carregar app
 */
let container;

if (currentScript.hasAttribute('data-container')) {
    container = currentScript.getAttribute('data-container')
}

/**
 * Mostrar formulário para o cliente
 */
let showFormCustomer = false;

if (currentScript.hasAttribute('data-show-form-customer')) {
    showFormCustomer = currentScript.getAttribute('data-show-form-customer') === 'true'
}

 /**
 * Descrição em inglês do ramo que está sendo utilizado no momento
 */

 let insureLine;

 if (currentScript.hasAttribute('data-insure-line')) {
    insureLine = currentScript.getAttribute('data-insure-line')
}

/**
 * Detectar se foi passado um ID de cotação
 */
let quotationId;

if (currentScript.hasAttribute('data-quotation-id')) {
    quotationId = currentScript.getAttribute('data-quotation-id')
}

/**
 * Trazer o resultado da cotação
 */
let loadResult = false;

if (currentScript.hasAttribute('data-load-result')) {
    loadResult = currentScript.getAttribute('data-load-result') === 'true'
}

/**
 * Path das logos das cias
 */
let imagesPath;

if (currentScript.hasAttribute('data-images-path')) {
    imagesPath = currentScript.getAttribute('data-images-path')
}

/**
 * Opção para mostrar botões de impressão
 */
let printResults = false;

if (currentScript.hasAttribute('data-print-results')) {
    printResults = currentScript.getAttribute('data-print-results') === 'true'
}

/**
 * Opção para deixar os campos e-mail, telefone e celular obrigatórios
 */
let contactValidate = false;

if (currentScript.hasAttribute('data-contact-validate')) {
    contactValidate = currentScript.getAttribute('data-contact-validate') === 'true'
}

/**
 * Opção para deixar o formulário centralizado
 */
let centeredForm = false;

if (currentScript.hasAttribute('data-centered-form')) {
    centeredForm = currentScript.getAttribute('data-centered-form') === 'true'
}

/**
 * Opção para deixar os botões de calcular/imprimir/comissões centralizado
 */
let centeredButtonsForm = false;

if (currentScript.hasAttribute('data-centered-buttons-form')) {
    centeredButtonsForm = currentScript.getAttribute('data-centered-buttons-form') === 'true'
}

/**
 * Opção para deixar o formulário centralizado
 */
let widthForm = '100%';

if (currentScript.hasAttribute('data-width-form')) {
    const dataWidthForm = currentScript.getAttribute('data-width-form')

    widthForm = /^[0-9]+$/.test(dataWidthForm) === true
        ? dataWidthForm + 'px'
        : dataWidthForm
}

/**
 * Opção para permitir ou não acesso a comissão
 */
let commissionAccess = true;

if (currentScript.hasAttribute('data-commission-access')) {
    commissionAccess = currentScript.getAttribute('data-commission-access') === 'true'
}

/**
 * Opção para permitir ou não acesso a seguradora
 */
let insurerAccess = true;

if (currentScript.hasAttribute('data-insurer-access')) {
    insurerAccess = currentScript.getAttribute('data-insurer-access') === 'true'
}

/**
 * Opção para permitir acesso às coberturas predefinidas
 */
let predefinedCoverage = false;

if (currentScript.hasAttribute('data-predefined-coverage')) {
    predefinedCoverage = currentScript.getAttribute('data-predefined-coverage') === 'true'
}

/* **
* Opção para designar a referencia (usuário, token, id) no sistema parceiro. Vinculo será feito com o cálculo, para saber a quem pertence o cálculo.
** */
let partnerReference = null;
if(currentScript.hasAttribute('data-partner-reference'))
{
    partnerReference = currentScript.getAttribute('data-partner-reference')
}

/* **
* Opção para identificar se a integração parte do Segfy.com
** */
let integrationIntercept = null
if(currentScript.hasAttribute('data-integration-intercept'))
{
    integrationIntercept = currentScript.getAttribute('data-integration-intercept')
}


/**
 * Export config...
 */
export default {
    environments,
    environment,
    token,
    tokenAdmin,
    container,
    showFormCustomer,
    quotationId,
    loadResult,
    imagesPath,
    printResults,
    contactValidate,
    centeredForm,
    centeredButtonsForm,
    widthForm,
    commissionAccess,
    insurerAccess,
    predefinedCoverage,
    partnerReference,
    integrationIntercept,
    insureLine,
    automationBearer
}



// WEBPACK FOOTER //
// ./src/shared/config.js